export class Constants {
  static readonly dateReceived = "Date Received";
  static readonly backendDateReceived = "dateReceived";
  static readonly scheduledStartDate = "Scheduled Start Date";
  static readonly backendScheduledStartDate = "dateScheduledStart";
  static readonly dateFormatEngb = "dd/MM/yyyy";
  static readonly dateFormaten029 = "MM/dd/yyyy";
  static readonly dateFormatEngbHistory = "dd-MM-yyyy HH:MM";
  static readonly dateFormaten029History = "MM-dd-yyyy HH:MM";
  static readonly date = "Date";
  static readonly dateConst = "date";
  static readonly type = "type";
  static readonly dateErrorAlert = "You cannot add two date filters at same time";
  static readonly duplicateFilterAlert = "You cannot add same filter again";
  static readonly visitIdErrorAlert = "You can only filter by one Visit ID at a time. Only alphanumeric characters and hyphens (-) are allowed.";
  static readonly scheduledStartActiveDate = "Tue Feb 23 2021 00:00:00";
  static readonly backendDateFormat = "yyyy-MM-ddTHH:mm";
  static readonly successStatus = "SUCCESS";
  static readonly reportMessage = "*The data shown is from the last 30 days";
  static readonly dispalyNameWoNumber = "Work Order Number(s)";
  static readonly dispalyNameVisitId = "Visit/Recommendation Id";
  static readonly displayNameReprocessVisitId = "Visit Id(s)";
  static readonly displayNameReprocessWoNumber = "Work Order Number(s)";
  static readonly displayNameWoId = "Work Order Id";
  static readonly displayNameServiceCoverRef = "Service Cover Ref";
  static readonly downloadPOSLinkBackendName = "Download";
  static readonly downloadInvoiceLinkBackendName = "Download";
  static readonly downloadPOSLinkBackendNameNA = "Not applicable";
  static readonly viewPestInfoLinkBackendNameNA = "Not applicable";
  static readonly InvoicePopUpBackendName = "Popup";
  static readonly status = "Status";
  static readonly classification = "Classification";
  static readonly contractNumber = "Contract Number";
  static readonly accountNumber = "Account Number";
  static readonly backOfficeId = "BackOffice Worksite ID";
  static readonly fmStoreId = "FM Store ID";
  static readonly address = "Address";
  static readonly postCode = "Post/Zip Code";
}
